import { render, staticRenderFns } from "./StaticSectionContact.vue?vue&type=template&id=3ee60a37"
import script from "./StaticSectionContact.vue?vue&type=script&lang=js"
export * from "./StaticSectionContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports